import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    width: '100%',
    height: '100%',

    backgroundColor: theme.colors.white,
});
